//Заголовок
export const Title = ({txt, style}) => {
  return (
    <div className = "cmp-format-about-title">{txt}</div>
  )
}